import { Dispatch, ReactNode, SetStateAction, useEffect } from 'react';

import Close from '../../../assets/Close.svg';
import { useSideMenuContext } from '../../../context/useSideMenu';
import { returnIcon } from '../../../utils/returnIcon';
import { ContainerOverlayModal, ContentModal, ContentInfo } from './styles';

export interface IModal {
  isOpen: boolean;
  closeModal: Dispatch<SetStateAction<boolean>>;
  titleModal: string;
  option: any;
  medium?: boolean;
  headerAction?: ReactNode;
  compactHeader?: boolean;
  large?: boolean;
  closeOnEscAndBackdrop?: boolean;
}

export const ModalInfoTemplete = ({
  children,
  closeModal,
  isOpen,
  titleModal,
  option,
  medium,
  headerAction,
  compactHeader,
  large,
  closeOnEscAndBackdrop,
}: any) => {
  const { sideMenuWidth } = useSideMenuContext();

  useEffect(() => {
    if (!isOpen || !closeOnEscAndBackdrop) return undefined;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') closeModal(false);
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, closeOnEscAndBackdrop]);

  const RenderHeader = () => {
    const iconSrc = returnIcon({ option });
    return (
      <header>
        <div>
          {iconSrc && <img src={iconSrc} alt="" />}
          <span>{titleModal}</span>
        </div>
        {headerAction}
        <img
          className="header-filter-close-button"
          src={Close}
          onClick={() => closeModal(false)}
        />
      </header>
    );
  };
  return (
    <ContainerOverlayModal
      isOpen={isOpen}
      id="container-overlay-modal"
      width={sideMenuWidth}
      onClick={(event: React.MouseEvent<HTMLDivElement>) => {
        if (closeOnEscAndBackdrop && event.target === event.currentTarget) {
          closeModal(false);
        }
      }}
    >
      <ContentModal
        medium={medium}
        isOpen={isOpen}
        periodic={isOpen}
        compactHeader={compactHeader}
        large={large}
      >
        <div className="not-showed-modal">
          <RenderHeader />
          <ContentInfo large={large}>{children}</ContentInfo>
        </div>
      </ContentModal>
    </ContainerOverlayModal>
  );
};
